var React = require('react');

function Edit (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.68057 5.1192L6.8839 3.32253L8.18257 2.0232L9.97857 3.8192L8.68057 5.1192ZM4.05457 9.74986L2.0699 9.93053L2.2459 7.95986L5.99057 4.2152L7.7879 6.01253L4.05457 9.74986ZM10.9372 2.89187L10.9366 2.8912L9.11123 1.06586C8.61723 0.573198 7.76857 0.549864 7.30057 1.01986L1.30323 7.0172C1.0859 7.23387 0.951233 7.52187 0.923233 7.82653L0.670566 10.6065C0.653233 10.8032 0.723233 10.9979 0.863233 11.1379C0.989233 11.2639 1.15923 11.3332 1.33457 11.3332C1.35523 11.3332 1.37523 11.3325 1.39523 11.3305L4.17523 11.0779C4.48057 11.0499 4.7679 10.9159 4.98457 10.6992L10.9826 4.7012C11.4679 4.21453 11.4472 3.40253 10.9372 2.89187Z","fill":"#0067DD"}));
}

Edit.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Edit;

Edit.default = Edit;
